document.addEventListener('DOMContentLoaded', () => {
  const productForm = document.querySelector('form[action="/cart/add"]');
  if (!productForm) return;

  const variantSelects = productForm.querySelectorAll('[name^="options"]');
  const productJSON = document.querySelector('[data-product-json]');
  if (!productJSON) return;

  let productData;
  try {
    productData = JSON.parse(productJSON.textContent);
  } catch (e) {
    console.error('Invalid product JSON', e);
    return;
  }

  const gallery = document.querySelector('.product-media, .media-gallery');
  const priceEl = document.querySelector('[data-product-price]');
  const compareEl = document.querySelector('[data-product-compare-price]');
  const skuEl = document.querySelector('[data-product-sku]');

  const formatMoney = (cents) => {
    if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
      return Shopify.formatMoney(cents, "{{ shop.money_format | strip_html | escape }}");
    }
    return `LE ${(cents / 100).toFixed(2)}`;
  };

  const updateProductPage = (variant) => {
    if (!variant) return;

    // 🖼️ Update gallery image
    if (gallery && variant.featured_image) {
      const mainImg = gallery.querySelector('img');
      if (mainImg) {
        mainImg.src = variant.featured_image.src;
        mainImg.alt = variant.title;
      }
    }

    // 💰 Update price
    if (priceEl) priceEl.textContent = formatMoney(variant.price);
    if (compareEl) {
      if (variant.compare_at_price > variant.price) {
        compareEl.textContent = formatMoney(variant.compare_at_price);
        compareEl.style.display = '';
      } else {
        compareEl.style.display = 'none';
      }
    }

    // 🔢 SKU
    if (skuEl) skuEl.textContent = variant.sku || '';

    // 🔗 URL
    const url = new URL(window.location.href);
    url.searchParams.set('variant', variant.id);
    window.history.replaceState({}, '', url);
  };

  const findSelectedVariant = () => {
    const selectedOptions = Array.from(variantSelects).map(select => select.value);
    return productData.variants.find(v => {
      return v.options.every((opt, idx) => opt === selectedOptions[idx]);
    });
  };

  variantSelects.forEach(select => {
    select.addEventListener('change', () => {
      const newVariant = findSelectedVariant();
      updateProductPage(newVariant);
    });
  });
});
